import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private selectedOrganizationSubject = new BehaviorSubject<string>('');
  public selectedOrganization$: Observable<string> = this.selectedOrganizationSubject.asObservable();

  constructor() { }

  setSelectedOrganization(organizationName: string) {
    this.selectedOrganizationSubject.next(organizationName);
  }

  getSelectedOrganization(): string {
    return this.selectedOrganizationSubject.value;
  }

  clearSelectedOrganization() {
    this.selectedOrganizationSubject.next('');
  }
}
